module.exports = __webpack_public_path__ + "static/media/home-icon.d3924240.svg";